import { ReactNode } from 'react';
import styles from './AnalyticsSubPage.module.scss';
import FilterSummary from '@customer/components/inputs/filter-summary/FilterSummary';
import FilterButton from '@customer/components/inputs/filter-button/FilterButton';
import { FilterGroup } from '@customer/filters/types';

interface AnalyticsSubPageProps {
  header?: ReactNode;
  content: ReactNode;
  countAll?: number;
  countFilter?: number;
  filters?: FilterGroup;
  transKey?: string;
  filteredTransKey?: string;
}

export const AnalyticsSubPage = ({
  header,
  content,
  countAll,
  countFilter,
  filters,
  transKey = 'ShowingAssets',
  filteredTransKey = 'ShowingFilteredAssets',
}: AnalyticsSubPageProps) => {
  return (
    <article className={styles.subpage}>
      <header className={styles.header}>
        <FilterSummary
          transKey={transKey}
          filteredTransKey={filteredTransKey}
          countAll={countAll}
          countFilter={countFilter}
          filterGroup={filters}
        />

        <div className={styles.header__actions}>
          {header}
          <FilterButton filters={filters} />
        </div>
      </header>

      <div className={styles.content}>{content}</div>
    </article>
  );
};

export default AnalyticsSubPage;
